<span [ngClass]="valueClass()">
    <svg-icon [src]="baseHref + 'assets/icons/pillars/' + icon()" [svgStyle]="iconStyle"></svg-icon>
</span>
